import axios from 'axios';
import * as qs from 'qs';
import { FAILURE, REQUEST, SUCCESS } from 'app/shared/reducers/action-type.util';
import { defaultValue, ITableType } from 'app/shared/model/commission-protectionPeriod.model';
import { ICrudGetListAction } from 'app/shared/model/list';
import { cleanEntity } from 'app/shared/util/entity-utils';
// 请求
export const ACTION_TYPES = {
  FETCH_REPORTMENT_LIST: 'protectionPeriod/FETCH_REPORTMENT_LIST', // 列表
  RESET: 'protectionPeriod/RESET' // 重置
};
// state
const initialState = {
  loading: false,
  fetching: false,
  loadMore: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<ITableType>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false
};

export type protectionPeriodState = Readonly<typeof initialState>;

// Reducer
export default (state: protectionPeriodState = initialState, action): protectionPeriodState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_REPORTMENT_LIST):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
        fetching: true
      };
    case FAILURE(ACTION_TYPES.FETCH_REPORTMENT_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        loadMore: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload
      };
    case SUCCESS(ACTION_TYPES.FETCH_REPORTMENT_LIST):
      return {
        ...state,
        loading: false,
        fetching: false,
        entities: action.payload.data || [],
        totalItems: parseInt(action.payload.data['totalElements'], 10)
      };
    case ACTION_TYPES.RESET:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

const apiUrl = '/fy/protection';
// 列表
export const getEntities: ICrudGetListAction<ITableType> = (page, size, sort = '', searchForm) => {
  const requestUrl = `${apiUrl}/list?page=${page}&size=${size}`;
  return {
    type: ACTION_TYPES.FETCH_REPORTMENT_LIST,
    payload: axios.get<ITableType>(`${requestUrl}`, {
      params: searchForm,
      paramsSerializer: params => qs.stringify(params)
    }),
    meta: { transformUserName: true }
  };
};

export const reset = () => ({
  type: ACTION_TYPES.RESET
});

// 更新
export function updateInfo(entity) {
  return new Promise((resolve, reject) => {
    axios
      .put(`${apiUrl}/update`, cleanEntity(entity))
      .then(response => {
        resolve(response.data);
      })
      .catch(() => {
        reject();
      });
  });
}

// 日志
export function getLog(id) {
  return new Promise((resolve, reject) => {
    axios
      .get(`${apiUrl}/${id}/log/list`)
      .then(response => {
        resolve(response.data);
      })
      .catch(() => {
        reject();
      });
  });
}
